import { ArrowRight } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import Reveal from "../shared/Reveal";
import GlowCTA from "../shared/effects/GlowCTA";

export const CtaSection = () => {
  const { t } = useLang();
  return (
    <section className="relative py-20 md:py-28" data-testid="cta-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
        <Reveal variant="scale" className="relative overflow-hidden rounded-3xl glass-strong border border-cyan-400/20 p-10 md:p-16">
          <div className="absolute -top-24 -right-24 w-80 h-80 bg-cyan-500/25 rounded-full blur-[120px]" />
          <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-blue-600/20 rounded-full blur-[140px]" />

          <div className="relative grid md:grid-cols-5 gap-8 items-center">
            <div className="md:col-span-3">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-strong">
                {t.cta.title}
              </h2>
              <p className="mt-4 text-mid text-base md:text-lg max-w-xl leading-relaxed">
                {t.cta.subtitle}
              </p>
            </div>
            <div className="md:col-span-2 flex md:justify-end">
              <GlowCTA
                to="/contact"
                data-testid="cta-button"
                className="bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-semibold px-6 py-4 rounded-xl shadow-[0_0_40px_rgba(0,229,255,0.35)] hover:shadow-[0_0_56px_rgba(0,229,255,0.6)] transition-colors"
              >
                {t.cta.button} <ArrowRight className="w-4 h-4" />
              </GlowCTA>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaSection;
